import { all, call, put, takeLatest } from 'redux-saga/effects';
import { packageOperations, packageTypes } from '../../store/package';
import { DAS_GET_TRANSPORT_STOPS_FAILED } from '../../constants/errors';
import { createError } from '../../store/errors';
import { getTransportStops } from '../../api/transport';

const { GET_TRANSPORT_STOPS } = packageTypes;

export const performGetTransportStops = function* performGetTransportStops({
  payload,
}) {
  const { getTransportStopsSuccess } = packageOperations;
  const {
    bookingRef,
    routeIds,
    date,
    departureLocation,
    arrivalLocation,
  } = payload;

  try {
    const outboundStops = yield call(
      getTransportStops,
      bookingRef,
      routeIds,
      date,
      departureLocation,
      arrivalLocation,
      'OUTBOUND',
    );
    const { error: outboundError, errors: outboundErrors } = outboundStops;
    const returnStops = yield call(
      getTransportStops,
      bookingRef,
      routeIds,
      undefined,
      arrivalLocation,
      departureLocation,
      'RETURN',
    );
    const { error: returnError, errors: returnErrors } = outboundStops;

    if (outboundError) {
      yield put(createError(outboundError));
    } else if (returnError) {
      yield put(createError(returnError));
    } else if (outboundErrors) {
      yield all(outboundErrors.map(error => put(createError(error))));
    } else if (returnErrors) {
      yield all(returnErrors.map(error => put(createError(error))));
    } else {
      yield put(
        getTransportStopsSuccess(bookingRef, outboundStops, returnStops),
      );
    }
  } catch (error) {
    yield put(
      createError({
        code: DAS_GET_TRANSPORT_STOPS_FAILED,
      }),
    );
  }
};

export default takeLatest(GET_TRANSPORT_STOPS, performGetTransportStops);
